<template>
  <div>
    <template v-if="$route.name === 'queryMachine'">
      <ots-main-title></ots-main-title>
      <div class="ots-title">
        <p>考试批次：{{ listName.planName }}</p>
        <p>考点：{{ listName.placeName }}</p>
        <p>教室名称：{{ listName.className }}</p>
      </div>
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
      ></ots-table-group-new>
    </template>
    <template v-else></template>
  </div>
</template>
<script>
import { queryExamListAPI } from "@/http/modules/computedRoomExam";
export default {
  data() {
    return {
      listName: "",

      tableData:[],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
      ],
      tableHeader: [
        {
          title: "考试机IP",
          prop: "ip",
          width: "240px",
        },
        {
          title: "座位号",
          prop: "seatNo",
          width: "240px"
        },
        {
          title: "",
          prop: "",
          formatter: () => {
            return " "
          }
        }
      ],
    };
  },
  mounted() {
    this.getTableData();
  },
  created() {
    this.listName = this.$route.query;
  },
  methods: {
    async getTableData() {
      let { serialNumber } = this.listName;
      let params = {
        serialNumber,
        page: 1,
        size: 10,
      }
      const { code, data } = await queryExamListAPI(params);
      if (code === 1) {
        this.tableData = data.records;
      }
    },

  },

};
</script>
<style lang="less" scoped>
.ots-title {
  display: flex;
  justify-content: space-between;
  background: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom:20px ;
}
</style>